import React, { useState, useRef, useEffect, useContext } from "react";

import { Box, Card, Container, Grid, Typography, TextField, Stack, Button, CircularProgress, Paper, InputLabel, OutlinedInput, InputAdornment, FormControl } from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import CmsContext from '../../store/cms-context';

import { getAccessJwtToken } from '../../store/globalUtilities';

import { useNavigate } from 'react-router-dom';

import { Storage } from 'aws-amplify';

import TimePicker from '@mui/lab/TimePicker';

import AdapterDateFns from '@mui/lab/AdapterDateFns';

import LocalizationProvider from '@mui/lab/LocalizationProvider';

import ReviewsAndCommentsDialog from "../ReviewsAndCommentsDialog/ReviewsAndCommentsDialog";

import cloneDeep from 'lodash/cloneDeep';


import ReviewsAndCommentsListTable from "../ReviewsAndCommentsListTable/ReviewsAndCommentsListTable";

import ToggleButtons from "../ToggleButtons/ToggleButtons";
import { has_admin_access, has_marketing_write_access } from "../../Utilities/HelperFunctions";



function ReviewsAndComments(props) {

  const cmsContext = useContext(CmsContext);

  const isMountedRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [all_reviews_and_comments, set_all_reviews_and_comments] = React.useState([]);

  const [selected_source, set_selected_source] = React.useState('trust_pilot_reviews');

  const [selected_source_id, set_selected_source_id] = React.useState('5cdbdacf7c4eb90bb86724a3');

  const [reviews_and_comments_dialog_state, set_reviews_and_comments_dialog_state] = React.useState({'review_comment': {}, is_dialog_open: false});

  const [next_token, set_next_token] = React.useState('');

  const [timestampOrder, setTimestampOrder] = React.useState('descending');

  const [hasMore, setHasMore] = React.useState(false);

  const [filter_tags, set_filter_tags] = React.useState('')

  const [filter_user_name, set_filter_user_name] = React.useState('')

  const [calendar_open, set_calendar_open] = React.useState(false);

  const [time_range, set_time_range] = React.useState('');

  const [ranges_button_text, set_ranges_button_text] = React.useState('Time range')

  const [QueryExecutionId, setQueryExecutionId] = React.useState('');


  useEffect(() => {

    isMountedRef.current = true

    get_reviews_and_comments(filter_user_name, filter_tags, time_range, timestampOrder, QueryExecutionId ,next_token, selected_source, selected_source_id)

    return () => isMountedRef.current = false;

  }, [])




  function handle_timestamp_order_change(tOrder){

    setTimestampOrder(tOrder)

    set_all_reviews_and_comments([])

    setQueryExecutionId('')

    set_next_token('')
    
    get_reviews_and_comments(filter_user_name, filter_tags, time_range, tOrder, '', '', selected_source, selected_source_id)

  }



  function onDateChange(ranges) {
    // ranges ...
   // alert("changed check the console log");

   if(ranges.startDate && ranges.endDate){


    set_ranges_button_text(ranges.startDate.toISOString().split('T')[0] + " - " + ranges.endDate.toISOString().split('T')[0])

    set_time_range(ranges.startDate.toISOString().split('T')[0] + "-to-" + ranges.endDate.toISOString().split('T')[0])

   }

    console.log("ranges: ", ranges);

  };

  function clearSearch(){

    set_all_reviews_and_comments([])

    set_time_range('')

    set_ranges_button_text('Time range')

    set_filter_tags('')

    set_filter_user_name('')

    setQueryExecutionId('')

    set_next_token('')

    get_reviews_and_comments('', '', '', timestampOrder, '', '', selected_source, selected_source_id)

  }

  function perform_search(){

    set_all_reviews_and_comments([])

    get_reviews_and_comments(filter_user_name, filter_tags, time_range, timestampOrder, '', '', selected_source, selected_source_id)

  }

  return(

    <>
   

   <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 8,
    }}
 
  >

    
    <Container maxWidth={false} style={{maxWidth:"1000px",overflow:'visible'}}>
  
    <Grid
        container
        spacing={2}
        style={{overflow:'visible'}}
      >

        <Grid
          item
          xs={12}
        >

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          spacing={2}
        >

          <Typography variant="h5">Reviews & Comments</Typography>

          <div>

          <ToggleButtons timestampOrder={timestampOrder} handle_timestamp_order_change={handle_timestamp_order_change}></ToggleButtons>

          </div>

        </Stack>

      </Grid>



         <Grid
            item
            xs={12}> 


            <ReviewsAndCommentsListTable
            perform_search={perform_search}
            onDateChange={onDateChange}
            calendar_open={calendar_open}
            set_calendar_open={set_calendar_open}
            filter_user_name={filter_user_name} 
            set_filter_user_name={set_filter_user_name} 
            filter_tags={filter_tags} 
            set_filter_tags={set_filter_tags}
            timestampOrder={timestampOrder} handle_timestamp_order_change={handle_timestamp_order_change}
            set_dialog={set_dialog}
            clearSearch={clearSearch}
            all_reviews_and_comments={all_reviews_and_comments}
            ranges_button_text={ranges_button_text}
            set_all_reviews_and_comments={ () =>{}}
            >


            </ReviewsAndCommentsListTable>

            </Grid>
          


      <Grid item xs={12}>


      {isLoading ? <div style={{textAlign:'center', marginTop:40}}> <CircularProgress /> </div> : null}

      </Grid>

     { <Grid item xs={12} >

      <div style={{width:'100%', textAlign:'center'}}>
      {hasMore && !isLoading ? <Button variant="contained" onClick = {() => {get_reviews_and_comments(filter_user_name, filter_tags, time_range, timestampOrder, QueryExecutionId, next_token, selected_source, selected_source_id)}}>Load more</Button> : null}

      </div>
  </Grid> }

    </Grid>
        
    </Container> 

    <ReviewsAndCommentsDialog reviews_and_comments_dialog_state={reviews_and_comments_dialog_state} set_reviews_and_comments_dialog_state={set_reviews_and_comments_dialog_state}></ReviewsAndCommentsDialog>

    </Box>


    </> 


  );


  function refresh(){

    console.log('refresh called')

  }



  function set_dialog(review_comment, is_open) {

    const dialog_state = {}

    dialog_state.review_comment = cloneDeep(review_comment)

    dialog_state.is_dialog_open = is_open

    set_reviews_and_comments_dialog_state(dialog_state)

  }

  async function get_picture_async(key, index){

    const picUrl = await Storage.get(key, {
      level: 'public',
      bucket: 'snag-cms175447-staging',
      expires:86400,
      region: 'eu-west-2',
    });

    console.log('url was', picUrl)

    set_all_reviews_and_comments((previous_tags) => {

      const temp_tags = [...previous_tags]

      if(index < temp_tags.length){
        temp_tags[index].url = picUrl;
      }

      return(set_all_reviews_and_comments(temp_tags))

    })

  }

  function get_reviews_and_comments(filter_user_name, filter_tags, time_range, timestampOrder, QueryExecutionId, next_token, selected_source, source_id) {

    console.log('store_access_token')

    // user api

    // error handling and state managment required

    console.log("selected source was: ", selected_source)

    setIsLoading(true)

    // Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,NextToken,QueryExecutionId,is_ascending,user_name,tags,time_range,request_type,source_id



    getAccessJwtToken().then((auth_creds)=>{

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/customer/reviews_comments',{
          crossDomain:true,
          method: 'GET',
          headers: {
            'Authorization':auth_creds.jwt,
            'NextToken': next_token,
            'QueryExecutionId': QueryExecutionId,
            'is_ascending': timestampOrder === 'ascending' ? "ASC" : "DESC",
            'user_name': filter_user_name,
            'tags': filter_tags.replaceAll("'","cms_apostraphe"),
            'time_range': time_range,
            'request_type': selected_source,
            'source_id': source_id
          }})
          .then(res => res.json())
          .then(
            (result) => {
              
              setIsLoading(false)
  
              console.log('result was: ', result)

              if(result.data){

                console.log('setting analytics')

                result.data.reviews.forEach((review) =>{
                  review.is_checked = false
                })

                if(result.data.reviews.length === 0){

                  setHasMore(false)
                  cmsContext.setSnackBarOpen(true, "info", "No tags found. Please select a different search criteria.")

                }

                var temp_reviews = [...all_reviews_and_comments]

                if(QueryExecutionId.length === 0){
                  temp_reviews = []
                }

                temp_reviews = temp_reviews.concat(result.data.reviews)

                console.log('setting all: ', temp_reviews)

                set_all_reviews_and_comments(temp_reviews)

                /*

                for(var tag_index in temp_tags){

                  if((!temp_tags[tag_index].url)  && temp_tags[tag_index].s3_key && temp_tags[tag_index].s3_key.length > 0){
         
                    get_picture_async(temp_tags[tag_index].s3_key, tag_index)

                  }

                }

                if(result.NextToken){

                  set_next_token(result.NextToken)

                  if(Object.keys(result.NextToken).length > 0){

                    setHasMore(true)

                  }else{

                    setHasMore(false)

                  }
                  
                }else{

                  setHasMore(false)
                  set_next_token('')

                }

                setQueryExecutionId(result.QueryExecutionId)
                
                */

              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                
              } else{

                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)

              }
  
            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('error was',error)
            }
           
      )

    })


  }


  function set_dialog_loading(is_loading){

    const temp_dialog_state = {...reviews_and_comments_dialog_state}

    temp_dialog_state.isLoading = is_loading

    set_reviews_and_comments_dialog_state(temp_dialog_state)

  }

  function reset_dialog_state(){

    set_reviews_and_comments_dialog_state(cloneDeep({}))

  }

  function post_instagram(instagram, request_type){

    set_dialog_loading(true)

    console.log('updating')

    var request_body = {}

    request_body.instagram = instagram

    request_body.request_type = request_type

    request_body.account_email = cmsContext.current_shop.email

    console.log('body was: ', request_body)

    getAccessJwtToken().then((auth_creds) => {

      if(!has_admin_access(auth_creds.current_user)){
        cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
        setIsLoading(false)
        return
      }

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/instagram_tags', {
          crossDomain:true,
          method: 'POST',
          headers: {
            'content-type':'application/json',
            'Authorization':auth_creds.jwt
          },
          body: JSON.stringify(request_body)
        })
          .then(res => res.json())
          .then(
            (result) => {
    
              console.log('result was',result)

              if(result.message){

                cmsContext.setSnackBarOpen(true, "success", result.message)
                reset_dialog_state()

                get_reviews_and_comments()
              
              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                set_dialog_loading(false)
                
              }else{

                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)
                set_dialog_loading(false)

              }
  
            },
        
            (error) => {
              set_dialog_loading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
              console.log('error was',error)
            }
      )

    })



  }

  function delete_instagram_tags(){

    console.log('delete instagram_tags')

    var temp_instagram_tags = [...all_reviews_and_comments].filter((instagram) => instagram.is_checked);

    console.log('filtered were', temp_instagram_tags)

    if(temp_instagram_tags.length === 0){
      // might never execute (need to select instagram_tags to display delete button)
      cmsContext.setSnackBarOpen(true, "error", "Please select valid instagram_tags!")
      return;
    }else if(temp_instagram_tags.length > 20){
      cmsContext.setSnackBarOpen(true, "error", "Please select a maximum of 20 instagram_tags!")
      return;
    }

    temp_instagram_tags = temp_instagram_tags.map((instagram) => {

      return({'id': instagram.id})

    })

    console.log('final instagram_tags were', temp_instagram_tags)

    const request_body = {}

    request_body.instagram_tags = temp_instagram_tags

    request_body.request_type = "delete"

    request_body.account_email = cmsContext.current_shop.email
    

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds)=>{

      if(!has_admin_access(auth_creds.jwt)){
        cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
        setIsLoading(false)
        return
      }


      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/instagram_tags',{
              crossDomain:true,
              method: 'POST',
              headers: {
                'content-type':'application/json',
                'Authorization':auth_creds.jwt
              },
              body: JSON.stringify(request_body)
            })
              .then(res => res.json())
              .then(
                (result) => {
      
                  setIsLoading(false)
  
                  console.log('result was',result)

                  if(result.message){

                    cmsContext.setSnackBarOpen(true, "success", result.message)

                    get_reviews_and_comments()
                  
                  }else if(result.errorMessage){

                    cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                    
                  }else{

                    cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                    console.log('Error', result)

                  }
                  
                },
            
                (error) => {
                  setIsLoading(false)
                  cmsContext.setSnackBarOpen(true, "error", error)
                  console.log('error was',error)
                }
          );
  
      });

  }


};


export default ReviewsAndComments;